interface IIcon {
  width?: string;
  color?: string;
  height?: string;
}
const WarningIcon = ({ width = '16', color = '#D9AA4F', height = '16' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <svg>
      <path
        d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375Z"
        fill="white"
      />
      <path
        d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375ZM6 9.375C5.5875 9.375 5.25 9.0375 5.25 8.625C5.25 8.2125 5.5875 7.875 6 7.875C6.4125 7.875 6.75 8.2125 6.75 8.625C6.75 9.0375 6.4125 9.375 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.58125 6.88125 6.31875 7.125 6 7.125C5.68125 7.125 5.41875 6.88125 5.3925 6.56625L5.14125 3.55875C5.1 3.05625 5.49375 2.625 6 2.625C6.48 2.625 6.8625 3.015 6.8625 3.4875C6.8625 3.51 6.8625 3.53625 6.85875 3.55875Z"
        fill={color}
      />
    </svg>
  </svg>
);

export default WarningIcon;
